import { render, staticRenderFns } from "./AsymmetricIcon.vue?vue&type=template&id=a5aa9442&"
import script from "./AsymmetricIcon.vue?vue&type=script&lang=js&"
export * from "./AsymmetricIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports